import { Injectable } from '@angular/core';
import { Sr } from '../interfaces/sr';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SrDetalle } from '../interfaces/srDetalle';
import { AuthService } from '../CookieAuth/auth.service';
import { ConfHttpService } from './conf-http.service';
import { DatePipe } from '@angular/common';
import { Cliente } from '../interfaces/cliente';
import { ClienteService } from './cliente.service';
// providers: [DatePipe]
@Injectable({
  providedIn: 'root'
})
export class SrService {
  // endpopint = 'http://api.crabslogistica.dotsystems.com.ar/api/';
  // endpopint = 'http://localhost:8000/api/';
  endpopint:string='';
  sr?:Sr[];
  headers:HttpHeaders = new HttpHeaders({'Content-Type': 'application/json'});
  constructor(private http:HttpClient, private cookie: AuthService, conf:ConfHttpService, private datePipe: DatePipe,private clienteService:ClienteService) {
    this.headers= new HttpHeaders({'Content-Type': 'application/json'});
    this.endpopint=conf.getBackend();
  }
  get()
  {
  return this.http.get<Sr[]>(this.endpopint+'sr');
  }
  getById(id:number)
  {
  return this.http.get<Sr>(this.endpopint+'srGetById/'+id);
  }
  getPendientes()
  {
  return  this.http.get<Sr[]>(this.endpopint+'srPendientes');
  }

  postNuevaSr(sr:Sr, srDetalle:SrDetalle[]){

    let id= this.http.post<number>(this.endpopint+'ingresarSR',sr ,{headers: this.headers}).toPromise().then(data =>{
      srDetalle.forEach(element => {
        console.log(element);
        element.id_sr=data;
        this.http.post(this.endpopint+'srDetalle',element ,{headers: this.headers}).toPromise();

      });

    });
    return id;
  }
  putSr(sr:Sr, srDetalle:SrDetalle[]){
    sr.token= this.cookie.getCookie();
    let idsolicitudRetiro=sr.id;
    console.log(sr);
    let id= this.http.post<number>(this.endpopint+'srupd/'+idsolicitudRetiro ,sr ,{headers: this.headers}).toPromise().then(data =>{
      srDetalle.forEach(element => {
        console.log(element);
        console.log('el id es '+ element.id);
        element.id_sr=data;
        if(element.id===undefined){

          this.http.post(this.endpopint+'srDetalle',element ,{headers: this.headers}).toPromise();
        }else{
          this.http.post(this.endpopint+'srDetalleUpd/'+element.id ,element ,{headers: this.headers}).toPromise();
        }


      });

    });
    return id;
  }
  getDetalle(id_sr:number){
    return this.http.get<SrDetalle>(this.endpopint+'srDetalleById/'+id_sr)
  }
  getHistorico(id_sr:number, id_et:number, dni:number, desde:Date,hasta:Date,estado:number){
    let cliente=0;

    // console.log(this.endpopint+'srgets/'+id_sr+'/'+id_et+'/'+dni+'/'+this.datePipe.transform(desde,"yyyy-MM-dd")+'/'+this.datePipe.transform(hasta,"yyyy-MM-dd")+'/'+estado+'/'+ this.cookie.getCookie().toString());
    return this.http.get<Sr[]>(this.endpopint+'srgets/'+id_sr+'/'+id_et+'/'+dni+'/'+this.datePipe.transform(desde,"yyyy-MM-dd")+'/'+this.datePipe.transform(hasta,"yyyy-MM-dd")+'/'+estado+'/'+ this.cookie.getCookie().toString()).toPromise();
  }
  postNewEstado(idsolicitudRetiro:number, estado:number)
  {
    // const headers= new HttpHeaders({'Content-Type': 'application/json'});
    let param={"estado":estado,"token":this.cookie.getCookie()};
    console.log(param)
    return this.http.post<string>(this.endpopint+'srEstado/'+idsolicitudRetiro,param ,{headers: this.headers}).toPromise();

  }

  consultaClienteSr(id_sr:number){
    return this.http.get<any>(this.endpopint+'getConsultaBySr/'+id_sr)
  }
  consultaClienteEt(id_et:number){
    return this.http.get<any>(this.endpopint+'getConsultaByEt/'+id_et)
  }
}
